<template>
  <div class="container">
    <el-button size="mini" style="min-width: 70px" v-bind="$attrs" @click="useDownload" :disabled="!!btnText || otherDisab">{{ btnText || text || '导出' }}</el-button>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
      center>
      <div style="width: 100%; text-align: center;">报表生成中，请到下载中心下载</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="toDownload">去下载</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'downloadButton',
  props: ['downloadApi', 'queryParams', 'text', 'otherDisab', 'gasId', 'companyId', 'isVio'],
  inheritAttrs: false,
  data () {
    return {
      dialogVisible: false,
      btnText: null,
      timer: null
    }
  },
  methods: {
    async useDownload () {
      // 如果是违规看板单独处理
      if (this.isVio) {
        this.queryParams.gasId = this.gasId
        this.queryParams.companyId = this.companyId
      }
      this.$emit('countPoint')
      const { code, message } = await this.downloadApi(this.queryParams)
      if ([0, 200].includes(code)) {
        this.dialogVisible = true
        this.countDown()
      } else if (code === 201) {
        this.$message.warning(`请于${message}秒后操作导出`)
      }
    },
    // 倒计时
    countDown () {
      let count = 60
      this.btnText = `${count--}s`
      this.timer = setInterval(() => {
        if (count === 0) {
          this.clearTimer()
          return
        }
        this.btnText = `${count--}s`
      }, 1000)
    },
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
      this.btnText = null
    },
    toDownload () {
      this.$emit('onChangePage')
      this.dialogVisible = false
      this.$router.push({ path: '/downloadCenter/index' })
    }
  },
  beforeDestroy () {
    this.clearTimer()
  }
}
</script>
<style lang="less" scoped>
  .container {
    display: inline-block;
    margin-left: 10px;
    /deep/ .el-dialog__header {
      background: #fff;
    }
  }
</style>
